<div class="add-associate-modal">
  <div class="dialog-header text-right" [ngStyle]="{
      'background-image':
        SharedService.actionType == 'delete'
          ? 'url(\'../../assets/images/deleteFingerPrint.svg\') !important'
          : 'url(\'../../assets/images/onboarding-image.svg\')'
    }">
    <img src="../../../assets/images/forgot-password-close-icon.svg" class="close" (click)="closeFingerprintModal(true)" />
  </div>
  <div class="dialog-body text-center scroll-bar">

    <div class="dialog-container">

      @if (isOnboardingVisible) {
        <div class="table-responsive w-100">
          <table class="table m-0">
            <thead>
              <tr class="mat-header-cell">
                <th>NAME/PHONE NUMBER</th>
                <th>FLEX ID/SITE CODE</th>
              </tr>
            </thead>
            <ng-container>
              <tbody class="user-list">
                <tr>
                  <td class="mat-cell">
                    <div class="d-flex align-item-center gap-2">
                      <div class="name-icon">
                        <p class="prof" style="cursor: auto">
                          {{assoDataHRIS.first_name[0] || '-'}}
                        </p>
                      </div>
                      <div class="user-des">
                        <p class="name font-weight-bold">
                          {{ assoDataHRIS.first_name }}
                        </p>
                        <p class="mobile">{{ assoDataHRIS.contact }}</p>
                      </div>
                    </div>
                  </td>
                  <td class="mat-cell">
                    <p class="flex font-weight-bold flexId">
                      {{ assoDataHRIS.external_id }}
                    </p>
                    <p class="site-name" style="text-align: left">
                      {{ assoDataHRIS.site }}
                    </p>
                  </td>
                </tr>
              </tbody>
            </ng-container>
          </table>
        </div>
      }

      @if (user.userDetails.role == 'superadmin' && showDropdown) {
        <div class="select">
          <mat-select placeholder="Select Registration Type" class="selectClass" (click)="onSelectClick()" (selectionChange)="regType($event)">
            <mat-option value="Manual Registration" class="option">Manual Registration</mat-option>
            <mat-option value="Biometric Registration" class="option">Biometric Registration</mat-option>
          </mat-select>
        </div>
      }


      @if (deviceInfo.loading) {
        <div class="msg-box device-success">
          <p>{{deviceInfo.loading}}</p>
        </div>
      }

      <!-- <div *ngIf="deviceInfo.error" class="msg-box error">
      <p>ErrorCode: {{deviceInfo.error.ErrorCode}}</p>
      <p>Desc: {{deviceInfo.error.ErrorDescription}}</p>
    </div> -->

    @if (fingerprint.error) {
      <div class="msg-box fp-error">
        <p>Fingerprint Capture ErrorCode: {{fingerprint.error.ErrorCode}}</p>
        <p>Desc: {{fingerprint.error.ErrorDescription}}</p>
      </div>
    }


    @if (error) {
      <div class="msg-box error">
        <p>{{error}}</p>
      </div>
    }

    @if (success) {
      <div class="msg-box success">
        <p>{{success}}</p>
      </div>
    }


    @if (enrollFailureStatus) {
      <div class="msg-box red-flag enroll-error">
        <p>Enroll Failed</p>
        <p>
          {{enrollFailureStatus}}
        </p>
      </div>
    }


    @if (!fingerprint.isCaptured && fingerprint.finger) {
      <div class="scan-actions">
        <img src="../../../assets/images/fingerprint-black.svg" class="image" />
        <p>Place your {{fingerprint.finger}} index finger</p>
      </div>
    }


    @if (fingerprint.isCaptured && fingerprint[fingerprint.finger] && fingerprint.inProgress) {
      <div
        class="scan-actions">
        <img src="../../../assets/images/Onboarding-auth-green.svg" class="image" />
        <p>{{fingerprint.finger}} index finger scanning was successful</p>
        <button (click)="captureFP('Right')">
          <span>Continue</span></button>
        </div>
      }

      @if (fingerprint.isCaptured && !fingerprint[fingerprint.finger]) {
        <div class="scan-actions">
          <img src="../../../assets/images/Onboarding-auth-red.svg" class="image" />
          <p>{{fingerprint.finger}} index finger scanning was failed</p>
          <button (click)="captureFP(fingerprint.finger)">
            <span>Try Again</span></button>
          </div>
        }

        @if (fingerprint.Left && fingerprint.Right) {
          <div class="scan-actions">
            <img src="../../../assets/images/Onboarding-auth-green.svg" />
            <p>Matching your fingerprints data..Please wait..</p>
          </div>
        }




        <!-- Add/Update Agent Details -->
        @if ((currentScanState == 'add' || currentScanState == 'update') && !success) {
          <form class="login-form" [formGroup]="associateForm" autocomplete="off">
            <div class="row m-1 mb-0">
              <div class="fm-title col-xs-12">Details</div>
              <div class="form-group">
                <label for="first name" class="required">First Name</label>
                <input class="form-control text-uppercase" type="text" formControlName="first_name"
                  [validateInput]="{ 'alpha-numeric': true }" placeholder="First Name" autocomplete="off" value=""
                  minlength="2" maxlength="30" readonly />
                  <div class="error-section">
                    @if (
                      associateForm.controls.first_name.errors &&
                      associateForm.controls.first_name.touched &&
                      associateForm.controls.first_name.dirty
                      ) {
                  <p class="err-msg" [hidden]="
                      !associateForm.get('first_name').hasError('required')
                    ">
                        First Name is required
                      </p>
                  <p class="err-msg" [hidden]="
                      !associateForm.get('first_name').hasError('minlength')
                    ">
                        Must have at least 2 characters
                      </p>
                    }
                  </div>
                </div>
                <div class="form-group">
                  <label for="last name" class="required">Last Name</label>
                  <input class="form-control text-uppercase" type="text" formControlName="last_name"
                    [validateInput]="{ 'alpha-numeric': true }" placeholder="Last Name" autocomplete="off" value=""
                    maxlength="30" readonly />
                    <div class="error-section">
                      @if (
                        associateForm.controls.last_name.errors &&
                        associateForm.controls.last_name.touched &&
                        associateForm.controls.last_name.dirty
                        ) {
                  <p class="err-msg" [hidden]="
                      !associateForm.get('last_name').hasError('required')
                    ">
                          Last Name is required
                        </p>
                      }
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="contact" class="required">Mobile Number</label>
                    <input class="form-control" formControlName="contact" type="text"
                      [validateInput]="{ 'mobile-number': true }" placeholder="Mobile Number" minlength="10" maxlength="10"
                      autocomplete="off" value="" readonly />
                      <div class="error-section">
                        @if (
                          associateForm.controls.contact.errors &&
                          associateForm.controls.contact.touched &&
                          associateForm.controls.contact.dirty
                          ) {
                  <p class="err-msg" [hidden]="
                      !associateForm.get('contact').hasError('required')
                    ">
                            Mobile Number is required
                          </p>
                  <p class="err-msg" [hidden]="
                      !associateForm.get('contact').hasError('minlength')
                    ">
                            Mobile Number must have 10 digits
                          </p>
                        }
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="city">Hiring Agency</label>
                      <input class="form-control text-uppercase" formControlName="agency" type="text"
                        placeholder="Hiring Agency" [validateInput]="{ 'alpha-numeric': true }" autocomplete="off" value=""
                        minlength="4" readonly />
                        <div class="error-section">
                          @if (
                            associateForm.controls.agency.errors &&
                            associateForm.controls.agency.touched &&
                            associateForm.controls.agency.dirty
                            ) {
                  <p class="err-msg" [hidden]="
                      !associateForm.get('agency').hasError('minlength')
                    ">
                              Must have at least 4 characters
                            </p>
                          }
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="city" class="required">Site Code</label>
                        <div>
                          <input formControlName="site" class="form-control" type="text" readonly />
                        </div>
                        <div class="error-section">
                          @if (
                            associateForm.controls.site.errors &&
                            associateForm.controls.site.touched &&
                            associateForm.controls.site.dirty
                            ) {
                            <p class="err-msg" [hidden]="!associateForm.get('site').hasError('required')">
                              Site Code is required
                            </p>
                            <p class="err-msg" [hidden]="!associateForm.get('site').hasError('minlength')">
                              Must have at least 4 characters
                            </p>
                          }
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="city" class="required">City</label>
                        <input class="form-control text-uppercase" formControlName="city" type="text" placeholder="City"
                          [validateInput]="{ 'alpha-numeric': true }" autocomplete="off" value="" minlength="3" maxlength="30"
                          readonly />
                          <div class="error-section">
                            @if (
                              associateForm.controls.city.errors &&
                              associateForm.controls.city.touched &&
                              associateForm.controls.city.dirty
                              ) {
                              <p class="err-msg" [hidden]="!associateForm.get('city').hasError('required')">
                                City is required
                              </p>
                              <p class="err-msg" [hidden]="!associateForm.get('city').hasError('minlength')">
                                Must have at least 3 characters.
                              </p>
                            }
                          </div>
                        </div>
                        <!-- *ngIf="currentScanState == 'add'" -->
                        <ng-container>
                          <div class="form-group">
                            <label for="city" class="required">Govt. ID Proof Type</label>
                            <!-- <select
                            class="form-control"
                            formControlName="govt_id_proof_type"
                            required
                            (change)="checkGovtProof($event, true)"
                            >
                            <option value="" disabled>Select ID Proof Type</option>
                            <option
                              *ngFor="let govtId of govtIdTypes"
                              [value]="govtId.value"
                              >
                              {{ govtId.type }}
                            </option>
                          </select> -->
                          <!-- <option value="Aadhar">Aadhar</option>
                          <option value="VOTER_ID">Voter ID</option>
                          <option value="Pan Card">PAN Card</option>
                          <option value="DRIVING_LICENCE">Driving License</option> -->
                          <div>
                            <input formControlName="govt_id_proof_type" class="form-control" type="text" readonly />
                          </div>
                          <div class="error-section">
                            @if (
                              associateForm.controls.govt_id_proof_type.errors &&
                              associateForm.controls.govt_id_proof_type.touched &&
                              associateForm.controls.govt_id_proof_type.dirty
                              ) {
                    <p class="err-msg" [hidden]="
                        !associateForm
                          .get('govt_id_proof_type')
                          .hasError('required')
                      ">
                                Govt. ID Proof Type is required
                              </p>
                            }
                          </div>
                        </div>
                        <div class="form-group">
                          <label for="city" class="required">Govt. ID Proof</label>
                          <input class="form-control text-uppercase" formControlName="govt_id_proof" type="text"
                            [validateInput]="{ 'alpha-numeric': true }" placeholder="Govt. ID Proof" autocomplete="off"
                            minlength="{{ govtPropfMinLength }}" maxlength="{{ govtPropfMaxLength }}" readonly />
                            <div class="error-section">
                              @if (
                                associateForm.controls.govt_id_proof.errors &&
                                associateForm.controls.govt_id_proof.touched &&
                                associateForm.controls.govt_id_proof.dirty
                                ) {
                    <p class="err-msg" [hidden]="
                        !associateForm.get('govt_id_proof').hasError('required')
                      ">
                                  Govt. ID Proof is required
                                </p>
                    <p class="err-msg" [hidden]="
                        !associateForm.get('govt_id_proof').hasError('min')
                      ">
                                  Must have at least {{ govtPropfMinLength }} characters
                                </p>
                    <p class="err-msg" [hidden]="
                        !associateForm.get('govt_id_proof').hasError('pattern')
                      ">
                                  Govt.ID is invalid
                                </p>
                              }
                            </div>
                          </div>
                          <div class="form-group">
                            <label for="job_type" class="required">Job Type</label>
                            <!-- <ng-select
                            class="add-associate-drop-down"
                            [items]="jobTypes"
                            formControlName="job_type"
                            bindLabel="jobType"
                            bindValue="jobType"
                            placeholder="Job Type"
                            name="job_type"
                            >
                          </ng-select> -->
                          <div>
                            <input formControlName="job_type" class="form-control" type="text" readonly />
                          </div>
                          <div class="error-section">
                            @if (
                              associateForm.controls.job_type.errors &&
                              associateForm.controls.job_type.touched &&
                              associateForm.controls.job_type.dirty
                              ) {
                    <p class="err-msg" [hidden]="
                        !associateForm.get('job_type').hasError('required')
                      ">
                                Job Type is required
                              </p>
                            }
                          </div>
                        </div>
                        @if (
                          associateFromHRIS &&
                          currentScanState === 'add' &&
                          flexIdPresentHRIS
                          ) {
                          <div class="form-group">
                            <label for="external_id">Amazon/Flex Id</label>
                            <input class="form-control text-uppercase" formControlName="external_id"
                              [validateInput]="{ 'alpha-numeric': true }" type="text" placeholder="Amazon/Flex Id" minlength="3"
                              maxlength="15" autocomplete="off" readonly />
                              <div class="error-section">
                    <p class="err-msg" [hidden]="
                        !associateForm.get('external_id').hasError('minlength')
                      ">
                                  Must have at least 3 characters.
                                </p>
                              </div>
                            </div>
                          }
                          @if (manual) {
                            <div class="form-group">
                              <label for="vendors" class="required">Vendor</label>
                              <!-- <ng-select
                              class="add-associate-drop-down"
                              [items]="vendors"
                              formControlName="vendor"
                              bindLabel="domainname"
                              bindValue="id"
                              [(ngModel)]="selectedVendor"
                              name="vendor"
                              (change)="vendorSelected($event)"
                              >
                            </ng-select> -->
                            <mat-select [(value)]="selectedVendor" placeholder="Select Vendor"
                              class="add-associate-drop-down dropdowns" (selectionChange)="vendorSelected($event)">
                              @for (vendor of vendors; track vendor) {
                                <mat-option value="{{ vendor.organizationname }}" class="option">
                                  <span>{{ vendor.organizationname }}</span>
                                </mat-option>
                              }
                            </mat-select>
                          </div>
                        }
                        @if (manual) {
                          <div class="form-group">
                            <label for="remarks" class="required">Remark</label>
                            <mat-select [(value)]="selectedRemark" placeholder="Select Remark"
                              class="add-associate-drop-down dropdowns" (selectionChange)="remarkSelected($event)">
                              @for (remark of remarks; track remark) {
                                <mat-option value="{{ remark.remarks }}" class="option">
                                  <span>{{ remark.remarks }}</span>
                                </mat-option>
                              }
                            </mat-select>
                            <!-- <ng-select
                            class="add-associate-drop-down"
                            [items]="remarks"
                            formControlName="remark"
                            bindLabel="remarks"
                            bindValue="id"
                            name="remarks"
                            [placeholder]="'Select Remark'"
                            [(ngModel)]="selectedRemark"
                            (change)="remarkSelected($event)"
                            >
                          </ng-select> -->
                        </div>
                      }
                      @if (
                        selectedRemark && selectedRemark == 'Others' ? true : false
                        ) {
                        <div class="form-group">
                          <label class="required" for="remark">Remark</label>
                          <input class="form-control text-uppercase remarkTxt" formControlName="remark" type="text"
                            placeholder="Remark" autocomplete="off" value="" />
                          </div>
                        }
                        @if (currentScanState === 'update' && permissions.update) {
                          <!-- <div
                          class="form-group"
                          *ngIf="isFlagEditable; else noFlagUpdate"
                          >
                          <label for="flag" class="required">Flag</label>
                          <select class="form-control" formControlName="flag" required>
                            <option value="" disabled>Select Flag</option>
                            <option value="ORANGE">Orange</option>
                            <option value="GREEN">Green</option>
                            <option value="RED">Red</option>
                          </select>
                          <ng-container
                    *ngIf="
                      associateForm.controls.flag.errors &&
                      associateForm.controls.flag.touched &&
                      associateForm.controls.flag.dirty
                    "
                            >
                            <p
                              class="err-msg"
                              [hidden]="!associateForm.get('flag').hasError('required')"
                              >
                              Flag is required
                            </p>
                          </ng-container>
                        </div>
                        <ng-template #noFlagUpdate>
                          <div class="form-group">
                            <label for="city" class="required">Flag</label>
                            <input
                              class="form-control text-capitalize"
                              formControlName="flag"
                              type="text"
                              placeholder="Flag"
                              />
                            </div>
                          </ng-template> -->
                          <div class="form-group">
                            <label for="external_id">Amazon/Flex Id</label>
                            <input class="form-control text-uppercase" formControlName="external_id"
                              [validateInput]="{ 'alpha-numeric': true }" type="text" placeholder="Amazon/Flex Id" minlength="3"
                              maxlength="15" autocomplete="off" />
                              <div class="error-section">
                    <p class="err-msg" [hidden]="
                        !associateForm.get('external_id').hasError('minlength')
                      ">
                                  Must have at least 3 characters.
                                </p>
                              </div>
                            </div>
                          }
                        </ng-container>
                        @if (showRemarkTxt) {
                          <div class="form-group">
                            <label class="required" for="job_type">Remark</label>
                            <input class="form-control text-uppercase" formControlName="remark" type="text" placeholder="Remark"
                              [validateInput]="{ 'alpha-numeric': true }" autocomplete="off" value="" />
                            </div>
                          }
                        </div>
                      </form>
                    }


                    <!-- After scan, if Match Found  -->
                    @if (currentScanState == 'exists' && flag.toLowerCase() != 'red') {
                      <div class="agent-info">
                        <div class="info-body table-responsive" [ngClass]="currentScanState == 'exists' ? 'removeColor' : ''">
                          <table class="table">
                            <tbody>
                              <tr>
                                <td>First Name</td>
                                <td class="text-capitalize">
                                  {{
                                  matchedAssociate.first_name
                                  ? matchedAssociate.first_name
                                  : "-"
                                  }}
                                </td>
                              </tr>
                              <tr>
                                <td>Last Name</td>
                                <td class="text-capitalize">
                                  {{
                                  matchedAssociate.last_name
                                  ? matchedAssociate.last_name
                                  : "-"
                                  }}
                                </td>
                              </tr>
                              <tr>
                                <td>Amazon/Flex ID</td>
                                <td>
                                  {{
                                  matchedAssociate.external_id
                                  ? matchedAssociate.external_id
                                  : "-"
                                  }}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <!-- <div class="text-center dilaog-container">
                      <div class="slider-wrapper">
                        <mat-slider name="progressData" min="0" max="100" [value]="progressData" percent thumbLabel>
                        </mat-slider>
                      </div>
                    </div> -->
                  }


                  @if (flag == 'green' && currentScanState === 'new') {
                    <div class="onboard-actions">
                      <img src="../../../assets/images/Onboarding-auth-green.svg" class="image" />
                      <p>New Associate</p>
                      <button (click)="onClickAdd()">
                        <span>ADD NEW ASSOCIATE</span>
                      </button>
                    </div>
                  }

                  @if (currentScanState == 'exists' && (flag == 'orange' || flag == 'green')) {
                    <div class="onboard-actions">
                      <img src="../../../assets/images/Onboarding-auth-green.svg" class="image" />
                      <p>User Data Exists</p>
                      <button (click)="onClickUpdate()">
                        <span>UPDATE & CONTINUE</span>
                      </button>
                    </div>
                  }


                  @if (
                    (currentScanState == 'exists' && flag.toLowerCase() == 'red') ||
                    (manual && currentScanState == 'failed')
                    ) {
                    <div class="onboard-actions red-flag">
                      <div class="red-flag">
                        <img src="../../../assets/images/Onboarding-auth-red.svg" class="image" />
                        <p>You cannot onboard this associate due to red flag.</p>
                      </div>
                      <div class="red-flag">
                        <p>Matched Associate : {{ matchedId }}</p>
                      </div>
                    </div>
                  }

                  @if (supportEmails) {
                    <div class="msg-box red-flag">
                      <p>For further queries, please reach out to us at</p>
                      <p>
                        ahemasha&#64;amazon.com<br />
                        scchampu&#64;amazon.com<br />
                        bas-support&#64;amazon.com<br />
                      </p>
                    </div>
                  }

                  @if (currentScanState == 'mismatch') {
                    <div class="msg-box red-flag">
                      @for (sentence of mismatchErr.split('.'); track sentence; let i = $index) {
                        <div>
                          @if (sentence.trim()) {
                            <p>{{ sentence.trim() }}</p>
                          }
                        </div>
                      }
                    </div>
                  }

                </div>

                <div class="btn-actions">

                  @if (!isRegisterFlowStarted && SharedService.actionType != 'delete') {
                    <div class="onboard-btn">
                      <div class="reader-select">
                        <span class="text">Fingerprint reader</span>
                        <mat-select class="selectClass" [value]="readerPreference" (selectionChange)="onReaderChange($event.value)">
                          @for (option of fpDevices.options; track option.value) {
                            <mat-option [value]="option.value" class="option">{{ option.label }}</mat-option>
                          }
                        </mat-select>
                      </div>
                      <label class="terms">
                        <input type="checkbox" [(ngModel)]="isChecked" style="margin-right: 10px;" />
                        <span class="text">
                          I Agree to the
                          <a style="text-decoration: none" href="/privacy-setting/privacy">
                            <span style="color: #00a8e1">Privacy Policy</span>
                          </a>
                        </span>
                      </label>
        <button type="button" [ngStyle]="{
          'pointer-events': isChecked ? 'auto' : 'none',
          'opacity': isChecked ? '1': '.5'
        }" (click)="onClickOnBoard(user.userDetails.role == 'superadmin')">
                        <span>START ONBOARDING</span>
                      </button>
                    </div>
                  }

                  @if (SharedService.actionType == 'delete') {
                    <button type="button" class="delete" (click)="deleteFingerPrint()">
                      <span>DELETE FINGERPRINT</span>
                    </button>
                  }

                  @if ((currentScanState == 'add' || currentScanState == 'update') && !success) {
                    <!-- [disabled]="associateForm.invalid || associateForm.pristine" -->
        <button [ngStyle]="{
          'pointer-events': isButtonEnabled ? 'auto' : 'none',
          'opacity': isButtonEnabled ? '1': '.5'
        }" type="button" (click)="onClickSave()">
                      <span>Save</span>
                    </button>
                  }

                  <!-- <ng-container *ngIf="manual && currentScanState == 'failed' && update">
                  <button type="button" (click)="closeFingerprintModal(true)">
                    <span> Dismiss </span>
                  </button>
                </ng-container> -->


                @if (flag.toLowerCase() == 'red') {
                  <button type="button" (click)="contactSupport()">
                    <span>Contact Support</span>
                  </button>
                }
                <!-- (flag == 'RED' || flag == 'red')" -->



                @if (closeButton) {
                  <button type="button" (click)="closeFingerprintModal(true)">
                    <span>Close</span>
                  </button>
                }

                <!-- <ng-container *ngIf="deviceInfo.error?.ErrorCode == -2027">
                <button type="button" (click)="checkFPServiceConnection()">
                  <span>Check Again</span>
                </button>
              </ng-container> -->



            </div>

          </div>
        </div>